module.exports = __webpack_public_path__ + "img/ic_16_add.7f332d74.svg";